"use client";

import { Link } from "@/i18n/routing";
import { Button, cn, Modal, ModalBody, ModalContent, ModalHeader, Spacer, useDisclosure } from "@heroui/react";
import { useTranslations } from "next-intl";
import useNotification from "./hooks/use-notification";
import { useCallback, useState } from "react";
import { Howl } from "howler";
import Image from "next/image";
import { NotificationProps } from "@/lib/declarations";
import { ReadNotificationAction } from "@/lib/notification-actions";
import { useDepositSucceedEvent } from "@/lib/hooks";

const notificationAudio = new Howl({
  src: "/notification.wav",
});

export default function NotificationPopup({ isLoggedIn }: { isLoggedIn: boolean }) {
  const t = useTranslations();
  const [notice, setNotice] = useState<NotificationProps>();
  const { isOpen: isNoticeOpen, onOpen: onNoticeOpen, onOpenChange: onOpenNoticeChange, onClose } = useDisclosure();

  useNotification(isLoggedIn, (e) => {
    console.log(e);
    notificationAudio.play();
    setNotice(e);
    onNoticeOpen();
  });
  const depositSucceedEvent = useDepositSucceedEvent([notice]);
  return (
    <Modal
      isOpen={isNoticeOpen}
      onOpenChange={onOpenNoticeChange}
      classNames={{
        header: "bg-[#0A2A27] text-center shadow-lg rounded-t-lg",
        body: "bg-[#021517]",
        footer: "bg-[#021517]",
        closeButton: cn("hover:bg-white/5 active:bg-white/10"),
      }}
      isDismissable={false}
      hideCloseButton
      defaultOpen
    >
      <ModalContent>
        <ModalHeader>{t("new-notification")}</ModalHeader>
        <ModalBody>
          <div className="flex w-full flex-col items-center justify-center gap-2 p-5">
            <Image src="/success/icon.webp" height={64} width={64} alt="background" className="mx-auto" />
            <div className="bg-gradient-to-r from-[#FFEA92] via-[#C9A04C] to-[#FFFFA5] bg-clip-text text-2xl font-bold text-transparent">
              {t("deposit-received")}
            </div>
            {notice && <div>{notice?.content}</div>}
          </div>
          <Button
            color="primary"
            className="mx-auto w-40"
            onPress={() => (
              onClose(),
              notice && (ReadNotificationAction(notice.id), depositSucceedEvent(notice), setNotice(undefined))
            )}
          >
            {t("ok")}
          </Button>
          <Spacer y={4} />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
